import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "columns is-multiline is-mobile px-2 is-centered" }
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_plan_card = _resolveComponent("plan-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "bold-text is-size-4 mb-5-mobile mb-6-tablet" }, "Please select a plan", -1)),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPlans, (plan, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: plan.id,
          class: "column is-half-mobile is-half-tablet is-one-quarter-desktop px-2-mobile px-3-tablet card-wrapper"
        }, [
          _createVNode(_component_plan_card, {
            plan: plan,
            bgImage: `${_ctx.leadsConstants.PLANS_BG_IMAGES[idx % _ctx.leadsConstants.PLANS_BG_IMAGES.length]}`
          }, null, 8, ["plan", "bgImage"])
        ]))
      }), 128))
    ]),
    _createElementVNode("button", {
      class: "button is-primary is-fullwidth mx-auto my-6 bold-text",
      disabled: !_ctx.isValidForPayment,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.nextStep && _ctx.nextStep(...args)))
    }, "Select", 8, _hoisted_2)
  ], 64))
}